import React from 'react'
import AutomationSettings from 'src/app/AutomationSettings/AutomationSettings'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import AutomationRulesAppRoute from 'src/navigation/appRoutes/organization/automationRules.appRoute'
import DepartmentDetailsAppRoute from 'src/navigation/appRoutes/organization/departmentDetails.appRoute'
import ExpenseCategoryLabelsAppRoute from 'src/navigation/appRoutes/organization/expenseCategoryLabels.appRoute'
import ExpenseSettingsAppRoute from 'src/navigation/appRoutes/organization/expenseSettings.appRoute'
import { organizationSettingsRouteProps } from 'src/navigation/routeProps'

const AutomationSettingsAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingAutomationSettings,
  routeProps: organizationSettingsRouteProps,
  component: <AutomationSettings />,
  subRoutes: [AutomationRulesAppRoute, ExpenseSettingsAppRoute],
  exceptions: [ExpenseCategoryLabelsAppRoute, DepartmentDetailsAppRoute],
  meta: { contentType: SidenavContentType.Settings },
}

export default AutomationSettingsAppRoute
